import { ListBulletIcon } from '@radix-ui/react-icons';
import {
  LayoutDashboard,
  Network,
  Settings2,
  BarChart2,
  GitGraph,
  Database,
  LineChart,
  Share2,
  Building2,
  Workflow,
  GitBranch,
  Link2,
  Activity
} from 'lucide-react';
import { LucideIcon } from 'lucide-react';

export interface NavigationSection {
  id: string;
  icon: any; // Using any to accommodate both Lucide and Radix icons
  label: string;
  title: string;
  subtitle: string;
}

export const navigationSections: NavigationSection[] = [
   {
    id: 'valueStreamPerformance',
    icon: Activity,
    label: 'Performance Analysis',
    title: "Performance Analysis",
    subtitle: "Monitor and analyze value stream performance"
  },
  {
    id: 'data-management',
    icon: ListBulletIcon,
    label: 'Enterprise Data',
    title: "Enterprise Data",
    subtitle: "Manage your organizational data"
  },
  {
    id: 'metrics',
    icon: BarChart2,
    label: 'Metrics',
    title: "Metrics",
    subtitle: "Explore and visualize your metrics"
  },
  // {
  //   id: 'model',
  //   icon: Network,
  //   label: 'Business Model View',
  //   title: "Business Model View",
  //   subtitle: "Visualize your end to end value streams"
  // },
  {
    id: 'settings',
    icon: Settings2,
    label: 'Settings',
    title: "Settings",
    subtitle: "Manage application settings"
  }
];

export const getSection = (id: string): NavigationSection => {
  return navigationSections.find(section => section.id === id) || navigationSections[0];
}; 